import PageBanner from '../components/PageBanner';
import './Services.css';

export default function Services() {
  return (
    <>
      <PageBanner 
        title="Our Services" 
        subtitle="Professional Real Estate Solutions"
      />
      <section className="page-section">
        {/* Your services content */}
      </section>
    </>
  );
}
